export const decodeHtml = (str) => {
  if (typeof str !== "string") return str;
  const doc = new DOMParser().parseFromString(str, "text/html");
  return doc.body.textContent || str;
};
